<template>
  <div id="footer" v-show="$route.path === '/login' || $route.path === '/forget' || $route.path === '/firmRegister' || $route.path === '/register' ? false : true ">
     <div>
		<span style="cursor: pointer;" @click="add()">备案号:冀ICP备2024047338号,</span>
		 <span>地址:石家庄市裕华区怀特商业广场A座905</span>
	 </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {


  },
  methods: {
    add(){
		let url = 'https://beian.miit.gov.cn/#/Integrated/index'
		open(url,'_blank')
	}
  },
  
}
</script>

<style scoped lang="scss">
#footer{
	min-width: 1500px;
	height: 60px;
	background-color: #fff;
	padding: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
